import React from "react";
import { W, H, PLANET_COLORS } from "./constants";

const PLANETS = ["Jupiter", "Venus", "Sun", "Moon", "Chiron"];
const ANGLES = { AC: "AC · Ascendant", IC: "IC · Imum Coeli", MC: "MC · Midheaven", DC: "DC · Descendant" };

function LegendChip({ planet, on, onToggle, children, className = "" }) {
  return (
    <button
      type="button"
      onClick={() => onToggle(planet)}
      data-testid={`legend-${planet.toLowerCase()}-line`}
      className={`text-[10px] uppercase tracking-[0.2em] px-2 py-1 border rounded-full transition-opacity ${className}`}
      style={{
        color: PLANET_COLORS[planet],
        borderColor: `${PLANET_COLORS[planet]}${on ? "AA" : "33"}`,
        background: on ? `${PLANET_COLORS[planet]}18` : "transparent",
        opacity: on ? 1 : 0.4,
      }}
    >
      {children}
    </button>
  );
}

export function LineLegend({ visibleLines, onToggle }) {
  return (
    <div className="mt-4 space-y-3">
      <div className="flex flex-wrap gap-2 items-center">
        <span className="text-[9px] uppercase tracking-[0.25em] text-[#A89C98] mr-1">Planetary</span>
        {PLANETS.map((p) => (
          <LegendChip key={p} planet={p} on={visibleLines[p]} onToggle={onToggle}>{p} Line</LegendChip>
        ))}
      </div>
      <div className="flex flex-wrap gap-2 items-center justify-between">
        <div className="flex flex-wrap gap-2 items-center">
          <span className="text-[9px] uppercase tracking-[0.25em] text-[#A89C98] mr-1">Angular</span>
          {Object.entries(ANGLES).map(([p, label]) => (
            <LegendChip key={p} planet={p} on={visibleLines[p]} onToggle={onToggle} className="flex items-center gap-1.5">
              <span aria-hidden className="inline-block" style={{ width: 6, height: 6, transform: "rotate(45deg)", background: PLANET_COLORS[p] }} />
              {label}
            </LegendChip>
          ))}
        </div>
      </div>
    </div>
  );
}

export function MapHeader({ city, lat, lng, score, scoreColor, onZoom, onReset }) {
  return (
    <div className="flex items-center justify-between mb-3 gap-3 flex-wrap">
      <div>
        <div className="text-xs uppercase tracking-[0.3em] text-[#A89C98]">Transit Cartography</div>
        <div className="font-heading text-lg sm:text-xl mt-1 capitalize">{city}</div>
        <div className="text-xs font-mono-scanner text-[#A89C98] mt-1">
          {lat.toFixed(2)}° {lat >= 0 ? "N" : "S"} · {Math.abs(lng).toFixed(2)}° {lng >= 0 ? "E" : "W"}
        </div>
      </div>
      <div className="flex items-center gap-2">
        <button data-testid="map-zoom-out" onClick={() => onZoom(1/1.3, W/2, H/2)} className="w-8 h-8 rounded border border-white/10 text-[#A89C98] hover:text-white hover:border-white/30 transition-colors">−</button>
        <button data-testid="map-zoom-in" onClick={() => onZoom(1.3, W/2, H/2)} className="w-8 h-8 rounded border border-white/10 text-[#A89C98] hover:text-white hover:border-white/30 transition-colors">+</button>
        <button data-testid="map-reset" onClick={onReset} className="px-2 h-8 rounded border border-white/10 text-[10px] uppercase tracking-widest text-[#A89C98] hover:text-white hover:border-white/30 transition-colors">Reset</button>
        <div className="font-mono-scanner text-3xl ml-2" style={{ color: scoreColor }}>{score}</div>
      </div>
    </div>
  );
}
